import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Accueil', href: '/' },
    { label: 'Programme', href: '/#program' },
    { label: 'Blog', href: '/blog' },
    { label: 'Avis Parents', href: '/avis-parents' },
    { label: 'Contact', href: '/#contact' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navigateToBlog = () => {
    window.REACT_APP_NAVIGATE('/blog');
    setIsMobileMenuOpen(false);
  };

  const navigateToTestimonials = () => {
    window.REACT_APP_NAVIGATE('/avis-parents');
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-between">
          {/* Logo et titre compacts */}
          <a href="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/8b031f960451367049584412e307a14c/4fa009778e5c57a642963c725d6b5624.png"
                alt="Garderie Les Petits Champions"
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className={`text-lg font-bold transition-colors ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              Garderie Les Petits Champions
            </h1>
          </a>

          {/* Menu de navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            <button onClick={() => scrollToSection('accueil')} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Accueil
            </button>
            <button onClick={() => scrollToSection('programme')} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Programme
            </button>
            <button onClick={() => scrollToSection('environnement')} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Environnement
            </button>
            <button onClick={() => scrollToSection('nutrition')} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Nutrition
            </button>
            <button onClick={navigateToBlog} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Blog
            </button>
            <button onClick={navigateToTestimonials} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Avis Parents
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Contact
            </button>
          </nav>

          {/* Menu mobile */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 cursor-pointer">
            <i className={`text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 bg-white rounded-lg shadow-lg p-4 space-y-3">
            <button onClick={() => scrollToSection('accueil')} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Accueil
            </button>
            <button onClick={() => scrollToSection('programme')} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Programme
            </button>
            <button onClick={() => scrollToSection('environnement')} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Environnement
            </button>
            <button onClick={() => scrollToSection('nutrition')} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Nutrition
            </button>
            <button onClick={navigateToBlog} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Blog
            </button>
            <button onClick={navigateToTestimonials} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Avis Parents
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-700 hover:text-orange-500 py-2 cursor-pointer">
              Contact
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}
